/** External project links referenced across sections. */
export const REMI_URL = 'https://remifitness.com';
